import { render, staticRenderFns } from "./DNS.vue?vue&type=template&id=2ba40a72&scoped=true"
import script from "./DNS.vue?vue&type=script&lang=js"
export * from "./DNS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba40a72",
  null
  
)

export default component.exports